import axios from "axios"
import OPTS from './options'

const ax = axios.create({
    baseURL: OPTS.api_url,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        [OPTS.csrf_header]: OPTS.csrf_value
    }
});

const axPref = axios.create({
    baseURL:  `${window.contextPath}/profilo/preferiti`,
    responseType: 'json',
    responseEncoding: 'utf8',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        [OPTS.csrf_header]: OPTS.csrf_value
    }
});

const autocompleteFilters = [
    ...OPTS.global_filters,
    ...(OPTS.selected_fund === 'all' ? [] : [`hier_id_ss: ${OPTS.selected_fund}`])
].join(' AND ');

const API = {
    async search(parameters) {
        let res = await ax.post(`/search`, parameters);

        return res.data;
    },

    async yearsMinMax(parameters) {
        let res = await ax.post(`/year-range`, parameters);

        return res.data;
    },

    async autocomplete(field, term) {
        let res = await ax.get(`/autocomplete`, {
            params: {
                f: field,
                t: term.trim(),
                q: autocompleteFilters
            }
        });

        return res.data;
    },

    addBookmark(id) {
        return axPref.post('/' + id)
    },

    removeBookmark(id) {
        return axPref.delete('/' + id)
    }
};

export default API;
